const options = defaultOptions => ({
  ...defaultOptions,
  plotOptions: {
    ...defaultOptions.plotOptions,
    area: {
      stacking: 'normal',
    },
  },

  chart: {
    ...defaultOptions.chart,
    type: 'area',
  },
});

export default options;
